<div class="tw-flex tw-flex-col tw-m-5">
    <div class="tw-text-[24px] tw-font-semibold tw-mb-4">
        {{ heading | translate }}
    </div>

    <!-- filter starts -->
    <div
        class="tw-flex tw-items-center tw-gap-4 tw-ring-1 tw-ring-inset tw-ring-gray-300 tw-rounded-2xl md:tw-rounded-none md:tw-ring-0 tw-bg-white md:tw-bg-transparent tw-mb-5"
    >
        <div class="filter-container tw-flex-1">
            <button
                class="md:tw-bg-white tw-h-[56px] md:tw-ring-1 md:tw-ring-inset md:tw-ring-gray-300 md:tw-rounded-2xl tw-p-[18px] tw-font-bold tw-flex tw-items-center tw-justify-center tw-gap-3 tw-w-full md:tw-w-[160px] tw-flex-1 md:tw-flex-auto"
                (click)="toggleFilter(!isFilterOpen)"
            >
                <mat-icon fontIcon="tune" class="tw-text-[22px]" />
                {{ "LNDP_CALENDAR.CATEGORY" | translate }}
            </button>
            <div
                *ngIf="isFilterOpen"
                class="tw-absolute tw-max-h-52 tw-overflow-x-auto tw-z-10 tw-mt-2 tw-w-[17rem] tw-origin-top-right tw-divide-y tw-divide-gray-100 tw-rounded-2xl tw-bg-white tw-shadow-lg tw-ring-1 tw-ring-black tw-ring-opacity-5 focus:tw-outline-none"
            >
                <!-- filter for main category starts -->
                <div class="tw-py-4 tw-px-5" role="none">
                    <div class="tw-py-1 tw-flex tw-items-center">
                        <input
                            type="checkbox"
                            class="tw-w-4 tw-h-4 show-cursor tw-mr-2 tw-accent-red-600"
                            [checked]="checkboxStates['Advisory Workshops']"
                            (click)="
                                onFilterProduct($event, 'Advisory Workshops')
                            "
                        />
                        <span class="tw-text-sm tw-font-semibold">
                            {{ "LNDP_CALENDAR.ADVISORY_WORKSHOP" | translate }}
                        </span>
                    </div>
                    <!-- filter for subcategories starts -->
                    <div class="tw-pl-6">
                        <div class="tw-py-1 tw-flex tw-items-center">
                            <input
                                type="checkbox"
                                class="tw-w-4 tw-h-4 show-cursor tw-mr-2 tw-accent-red-600"
                                [checked]="checkboxStates['Business Plan']"
                                (click)="
                                    onFilterProduct($event, 'Business Plan')
                                "
                            />
                            <span class="tw-text-sm tw-font-semibold">
                                {{ "LNDP_CALENDAR.BUSINESS_PLAN" | translate }}
                            </span>
                        </div>
                    </div>
                    <div class="tw-pl-6">
                        <div class="tw-py-1 tw-flex tw-items-center">
                            <input
                                type="checkbox"
                                class="tw-w-4 tw-h-4 show-cursor tw-mr-2 tw-accent-red-600"
                                [checked]="checkboxStates['Financial Literacy']"
                                (click)="
                                    onFilterProduct(
                                        $event,
                                        'Financial Literacy'
                                    )
                                "
                            />
                            <span class="tw-text-sm tw-font-semibold">
                                {{
                                    "LNDP_CALENDAR.FINANCIAL_LITERACY"
                                        | translate
                                }}
                            </span>
                        </div>
                    </div>
                    <div class="tw-pl-6">
                        <div class="tw-py-1 tw-flex tw-items-center">
                            <input
                                type="checkbox"
                                class="tw-w-4 tw-h-4 show-cursor tw-mr-2 tw-accent-red-600"
                                [checked]="
                                    checkboxStates['Marketing and Sales']
                                "
                                (click)="
                                    onFilterProduct(
                                        $event,
                                        'Marketing and Sales'
                                    )
                                "
                            />
                            <span class="tw-text-sm tw-font-semibold">
                                {{
                                    "LNDP_CALENDAR.MARKETING_SALES" | translate
                                }}
                            </span>
                        </div>
                    </div>
                    <div class="tw-pl-6">
                        <div class="tw-py-1 tw-flex tw-items-center">
                            <input
                                type="checkbox"
                                class="tw-w-4 tw-h-4 show-cursor tw-mr-2 tw-accent-red-600"
                                [checked]="checkboxStates['Halal']"
                                (click)="onFilterProduct($event, 'Halal')"
                            />
                            <span class="tw-text-sm tw-font-semibold">
                                {{ "LNDP_CALENDAR.HALAL" | translate }}
                            </span>
                        </div>
                    </div>
                    <div class="tw-pl-6">
                        <div class="tw-py-1 tw-flex tw-items-center">
                            <input
                                type="checkbox"
                                class="tw-w-4 tw-h-4 show-cursor tw-mr-2 tw-accent-red-600"
                                [checked]="checkboxStates['ESG']"
                                (click)="onFilterProduct($event, 'ESG')"
                            />
                            <span class="tw-text-sm tw-font-semibold">
                                {{ "COMMON.ESG" | translate }}
                            </span>
                        </div>
                    </div>
                    <div
                        class="tw-pl-6 tw-border-b-[1px] tw-border-placeholder-gray tw-pb-2.5"
                    >
                        <div class="tw-py-1 tw-flex tw-items-center">
                            <input
                                type="checkbox"
                                class="tw-w-4 tw-h-4 show-cursor tw-mr-2 tw-accent-red-600"
                                [checked]="checkboxStates['Business Expansion']"
                                (click)="
                                    onFilterProduct(
                                        $event,
                                        'Business Expansion'
                                    )
                                "
                            />
                            <span class="tw-text-sm tw-font-semibold">
                                {{
                                    "LNDP_CALENDAR.BUSINESS_EXPANSION"
                                        | translate
                                }}
                            </span>
                        </div>
                    </div>
                    <!-- Filter for sub-categories ends -->
                    <div
                        class="tw-py-4 tw-flex tw-items-center tw-border-b-[1px] tw-border-placeholder-gray"
                    >
                        <input
                            type="checkbox"
                            class="tw-w-4 tw-h-4 show-cursor tw-mr-2 tw-accent-yellow-400"
                            [checked]="checkboxStates['Access New Markets']"
                            (click)="
                                onFilterProduct($event, 'Access New Markets')
                            "
                        />
                        <span class="tw-text-sm tw-font-semibold">
                            {{ "LNDP_CALENDAR.ACCESS_NEW_MARKETS" | translate }}
                        </span>
                    </div>
                    <div class="tw-py-4 tw-flex tw-items-center">
                        <input
                            type="checkbox"
                            class="tw-w-4 tw-h-4 show-cursor tw-mr-2 tw-accent-green-700"
                            [checked]="checkboxStates['Networking Sessions']"
                            (click)="
                                onFilterProduct($event, 'Networking Sessions')
                            "
                        />
                        <span class="tw-text-sm tw-font-semibold">
                            {{ "LNDP_CALENDAR.NETWORKING_SESSION" | translate }}
                        </span>
                    </div>
                </div>
                <!-- filter for main category ends -->
            </div>
        </div>
    </div>
    <!-- filter ends -->

    <div
        class="tw-border-gray-300 tw-border-[1px] tw-p-4 tw-rounded-md tw-flex tw-justify-center"
    >
        <p-calendar
            [locale]="readLocalStorageValue('language')"
            [inline]="true"
            (onMonthChange)="onSelectMonth($event)"
        >
            <ng-template pTemplate="date" let-date>
                <div class="tw-flex tw-flex-col tw-items-center">
                    <span>{{ date.day }}</span>
                    <ng-container *ngFor="let event of eventDays">
                        <ng-container *ngIf="event.month == date.month">
                            <div
                                class="tw-w-1 tw-h-1 tw-bg-blue-800 tw-rounded-md"
                                *ngIf="event.day == date.day"
                            ></div>
                        </ng-container>
                    </ng-container>
                </div>
            </ng-template>
        </p-calendar>
    </div>

    <app-calendar-events
        [events]="events"
        (pickedLanguage)="changeMonthLanguage($event)"
    />

    <!-- display no events starts-->
    <div class="tw-flex tw-my-10" *ngIf="events.length === 0">
        <div class="tw-text-xl tw-font-semibold tw-mb-4 text-center">
            {{ "LNDP_CALENDAR.NO_EVENTS" | translate }}
        </div>
    </div>
    <!-- display no events ends-->
</div>
<app-loader [showLoader]="!apiResponse"></app-loader>
